import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import ProjectModel from "../../../models/ProjectModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface SetProjectImageModel {
    projectId: number
    concurrencyId: string
    fileName?: string
    fileResult?: FileCreateResultModel
}

interface IProps {
    show?: boolean
    onHide?: (projectImageUrl?: string) => void
    project: ProjectModel
}

const SetProjectImagePopup: React.FC<IProps> = ({ show, onHide, project }) => {
    const [title, setTitle] = useState<string>();
    const [file, setFile] = useState<File>();
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });

    const { handleResult, handleException } = useNotifications();
    const { translate } = useTranslations();

    const [formData, setFormData] = useState<SetProjectImageModel>();

    useEffect(() => {
        translate('Set project imaget').then(translated => setTitle(translated));
        setFormData({
            projectId: project.id,
            concurrencyId: project.concurrencyId
        })
    }, [project]);


    function submit() {
        if (formData && file) {
            DataService
                .createFile(file)
                .then(fileResponse => {
                    handleResult(fileResponse);
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        DataService
                            .create<SetProjectImageModel>(`api/v1/Projects/SetProjectImage`, formData)
                            .then(response => {
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    if (onHide) {
                                        if (fileResponse.data)
                                            onHide(fileResponse.data.thumbnailFileUrl);
                                        else
                                            onHide();
                                    }
                                }
                            })
                            .catch(e => handleException(e));
                    }
                    else {
                        handleResult(fileResponse);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (formData) {
            if (name === 'fileName' && typeof (value) === 'object') {
                setFile(value);
                formData.fileName = value.name;
            }
            setFormData(formData);
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'fileName', label: 'File', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FileUploadField {...getFieldProps('fileName')} />
            </Modal.Body>
            <Modal.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Modal.Footer>
        </Modal>
    );
}
export default SetProjectImagePopup;